// vibra pay 支付协议
export const vibraPayAgreementUrl = 'https://vibra.zendesk.com/hc/en-gb/articles/7667128811673'